import lazulitop from "../../image/flirty-lazuli/lauzlitop.webp";

import Items from './Item'


const Shop = () => {
  const items = [
    {
      id: "103",
      name: "Flirty Lazuli Top",
      image: lazulitop,
      price: "$120",
      thumbnails: [lazulitop],
      description:
        "With black RT monogram on baby blue with neon seam. 95% poly 5% spandex (feels like silk on your skin)  Designed in UK, Made in Los Angeles.  The color may vary due to lighting on the images. The product images (without models) are closest to the true color of the product Hand wash cold and hang dry.",
      projectUrl:
        "",
      sizes: ["Small", "Medium", "Large", "XLarge"],
    },
  ];
    

  return (
    <Items items={items} />
  )
}

export default Shop;
